import React from 'react';
import { Box, Container, Typography, Grid, Link } from '@mui/material';
import Logo from './Logo';

const Footer: React.FC = () => {
  return (
    <Box sx={{ bgcolor: '#0a0a1a', py: 8, borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
              <Logo size={40} />
              <Typography variant="h6" sx={{ fontWeight: 700, color: 'white' }}>
                Sakura ShiftSync
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
              Intelligent scheduling and shift management for modern healthcare organizations.
            </Typography>
          </Grid>
          
          <Grid item xs={6} md={2}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'white', mb: 2 }}>
              Product
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="#" color="inherit" underline="none" sx={{ opacity: 0.7 }}>
                Features
              </Link>
              <Link href="#" color="inherit" underline="none" sx={{ opacity: 0.7 }}>
                Pricing
              </Link>
              <Link href="#" color="inherit" underline="none" sx={{ opacity: 0.7 }}>
                Integrations
              </Link>
              <Link href="#" color="inherit" underline="none" sx={{ opacity: 0.7 }}>
                API
              </Link>
            </Box>
          </Grid>
          
          <Grid item xs={6} md={2}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'white', mb: 2 }}>
              Company
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="#" color="inherit" underline="none" sx={{ opacity: 0.7 }}>
                About
              </Link>
              <Link href="#" color="inherit" underline="none" sx={{ opacity: 0.7 }}>
                Careers
              </Link>
              <Link href="#" color="inherit" underline="none" sx={{ opacity: 0.7 }}>
                Blog
              </Link>
              <Link href="#" color="inherit" underline="none" sx={{ opacity: 0.7 }}>
                Contact
              </Link>
            </Box>
          </Grid>
          
          <Grid item xs={6} md={2}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'white', mb: 2 }}>
              Support
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="#" color="inherit" underline="none" sx={{ opacity: 0.7 }}>
                Help Center
              </Link>
              <Link href="#" color="inherit" underline="none" sx={{ opacity: 0.7 }}>
                Documentation
              </Link>
              <Link href="#" color="inherit" underline="none" sx={{ opacity: 0.7 }}>
                Status
              </Link>
            </Box>
          </Grid>
          
          <Grid item xs={6} md={2}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'white', mb: 2 }}>
              Legal
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="#" color="inherit" underline="none" sx={{ opacity: 0.7 }}>
                Privacy
              </Link>
              <Link href="#" color="inherit" underline="none" sx={{ opacity: 0.7 }}>
                Terms
              </Link>
              <Link href="#" color="inherit" underline="none" sx={{ opacity: 0.7 }}>
                Security
              </Link>
            </Box>
          </Grid>
        </Grid>
        
        <Box sx={{ mt: 8, pt: 4, borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>
          <Typography variant="body2" align="center" sx={{ color: 'rgba(255, 255, 255, 0.5)' }}>
            © {new Date().getFullYear()} Sakura ShiftSync. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
